
import { Vue, Component } from 'vue-property-decorator';
import VoteButton from '@/components/next/VoteButton.vue';
import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/css/swiper.min.css';
import { getIndex } from '../api';
@Component({
  components: {
    VoteButton,
  },
})
export default class Home extends Vue {
  already: boolean = false;
  voteName: string = '2022project/q1/2022forever';
  imgList: any = [
    { text: require('../assets/组件1.png') },
    { text: require('../assets/组件2.png') },
    { text: require('../assets/组件3.png') },
    { text: require('../assets/组件4.png') },
    { text: require('../assets/组件5.png') },
    { text: require('../assets/组件6.png') },
    { text: require('../assets/组件7.png') },
    { text: require('../assets/组件8.png') },
  ];
  voteImg: any = [
    { url: require('../assets/献花.png') },
    { url: require('../assets/已献花.png') },
  ];
  mounted() {
    this.swiper();
    this.vote();
  }
  async vote() {
    const data = {
      unionid: window.localStorage.getItem('unionid'),
      udid: window.udid,
      appkey: window.appkey,
    };
    const res: any = await getIndex(data);
    if (res.code === 500) {
      this.already = true;
    }
  }
  swiper() {
    const swipe = new Swiper('.swiper-container', {
      loop: true,
      slidesPerView: 'auto',
      loopedSlides: 5,
      autoplay: {
        delay: 3000, // 每次轮播间隔的ms数，默认3000ms
      },
    });
  }
  votSuccess(data: any) {
    this.vote();
  }
}
